import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import { memberPortal } from "../member-portal";
import { adobeDataLayerWrapper } from "../adobeDataLayerMethod";
require('parsley');

export class memberUpdateProfile {
	private updateForm:any   = $('#member-profile-update');
	private memberBase:any = new memberPortal();
	

	/**
	 * initialize all form inputs with focus and filled effects
	 * find all instances of text inputs in all 3 forms on page
	 * combine them into an array and apply effect to all fields
	 * @return {any} [description]
	 */
	initTextInputs(): any {
		let _self = this;
		let inputElArr:any = $.makeArray(_self.updateForm.find('input[type="text"], input[type="email"]'));
		let $updateProfileFlag:any  = $('#updateProfileFlag').val();
		
		if($updateProfileFlag=="false")
		{
			// disable input fields
			let toDisableInputs:any = _self.updateForm.find('#update-profile--first-name, #update-profile--last-name, #update-profile--personal-email, #update-profile--booktitle');
		
				toDisableInputs.each((i:number, el:any) => {
					$(el).attr({
						'disabled': 'disabled'
					});
					$(el).prev().css({
						'background-color': '#eee',
						'border-top-left-radius':'10px',
						'border-top-right-radius': '10px'
					});
		
				});				
		}
		
		_self.memberBase.initFormTextInputs(inputElArr);
	}


	/**
	 * [initSelectizeInputs description]
	 * @return {any} [description]
	 */
	initSelectizeInputs(): any {
		let _self = this;
		var titleInput = $('#update-profile--title');
		var getTitleOptions = $.Deferred();
		let titlecodeurl:string = '';
		/*if (window.location.hostname === 'localhost' && window.location.port == "5000") {
			titlecodeurl = '/dummy-data/TitleCode.json';
		}
		else {
			titlecodeurl = '/content/dam/mas/json/TitleCode.json';
		}*/
		titlecodeurl = '/content/dam/mas/json/TitleCode.json';

		$.get(titlecodeurl)
		.done((data:any) => {
			var listItems = "<option value=''> </option>";
			if (window.location.hostname === 'localhost' && window.location.port == "5000") {
				if (typeof data === 'string') {
					data=JSON.parse(data);
				}
			}	
			for (var i = 0; i < data.Titles.length; i++) {
				listItems += "<option value='" + data.Titles[i].Code + "'>" + data.Titles[i].Name + "</option>";
			}
			getTitleOptions.resolve(listItems);
		})
		.fail((error:any) => {
			getTitleOptions.reject(error);
		});

		var countryInput = $('.update-profile--personal-address-country select');		

		var getCountryOptions = $.Deferred();
		let countrycodeurl:string ='';
		/*if (window.location.hostname === 'localhost' && window.location.port == "5000") {
			countrycodeurl = '/dummy-data/countrycode.json';
		}
		else {
			countrycodeurl = '/content/dam/mas/json/countrycode.json';
		}*/
		countrycodeurl = '/content/dam/mas/json/countrycode.json';
		$.get(countrycodeurl)
		.done((data:any) => {
			var listItems = "<option value=''> </option>";
			if (window.location.hostname === 'localhost' && window.location.port == "5000") {
				if (typeof data === 'string') {
					data=JSON.parse(data);
				}
			}	
			for (var i = 0; i < data.Countries.length; i++) {
				listItems += "<option value='" + data.Countries[i].Code + "'>" + data.Countries[i].Name + "</option>";
			}
			getCountryOptions.resolve(listItems);
		})
		.fail((error:any) => {
			getCountryOptions.reject(error);
		});

		var nationalityInput = $('#update-profile--nationality');
		var businessCountryInput = $('#update-profile--business-address-country');

		var getNationalityOptions = $.Deferred();
		$.get(countrycodeurl)
		.done((data:any) => {
			var listItems = "<option value=''> </option>";
			if (window.location.hostname === 'localhost' && window.location.port == "5000") {
				if (typeof data === 'string') {
					data=JSON.parse(data);
				}
			}			
			for (var i = 0; i < data.Countries.length; i++) {
				listItems += "<option value='" + data.Countries[i].Code + "'>" + data.Countries[i].Name + "</option>";
			}
			getNationalityOptions.resolve(listItems);
		})
		.fail((error:any) => {
			getNationalityOptions.reject(error);
		});

		$.when(getTitleOptions, getCountryOptions).done(function(titleOptions:any, countryOptions:any) {
			titleInput.html(titleOptions);
			countryInput.html(countryOptions);
			nationalityInput.html(countryOptions);
			businessCountryInput.html(countryOptions);
			var inputSelectArr = $.makeArray(_self.updateForm.find('select'));
			_self.memberBase.initSelectizeInputs(inputSelectArr);
			_self.removeElementsforResponsiveness();
		});

	}

	removeElementsforResponsiveness(): any {
		let $divaddressitem: any = $('.update-address-item-desk');
		let $divaddressitemmobile: any = $('.update-address-item-mob');
		let $divinterestitem: any = $('.update-interest-item-desk');
		let $divinterestitemmobile: any = $('.update-interest-item-mob');
		let _self = this;
		if (window.innerWidth < 1199) {
			$divaddressitem.detach();
			$divinterestitem.detach();
			$divaddressitemmobile.appendTo('.update-profile-add-mob');
			$divinterestitemmobile.appendTo('.update-profile-int-mob');
		} else {
			$divaddressitemmobile.detach();
			$divinterestitemmobile.detach();
			$divaddressitem.appendTo('.update-profile-add-desk');
			$divinterestitem.appendTo('.update-profile-int-desk');
		}
		window.addEventListener("resize", function () {
			if (window.innerWidth < 1199) {
				$divaddressitem.detach();
				$divinterestitem.detach();
				$divaddressitemmobile.appendTo('.update-profile-add-mob');
				$divinterestitemmobile.appendTo('.update-profile-int-mob');				
			} else {
				$divaddressitemmobile.detach();
				$divinterestitemmobile.detach();
				$divaddressitem.appendTo('.update-profile-add-desk');
				$divinterestitem.appendTo('.update-profile-int-desk');				
			}
		})
	}

	populateFlightBookingTitle(): any {
		let $titleselect: any = $('#update-profile--title');
		let $genderselect: any = $('#update-profile--gender');
		let $bookingtitleinput: any = $('#update-profile--booktitle');		
		let $titleselectvalue = $titleselect.val();
		let $genderselectvalue = $genderselect.val();
		if ($genderselectvalue !== '' && $titleselectvalue !== '') {
			if ($genderselectvalue === 'M') {
				$bookingtitleinput.val('Mr');
			} else if ($genderselectvalue === 'F') {
				if ($titleselectvalue !== 'Mrs') {
					$bookingtitleinput.val('Miss');
				}
			}
		}
		if ($titleselectvalue !== '') {
			if ($titleselectvalue === 'Mrs') {
				$bookingtitleinput.val('Mrs');
			}
		}
	}

	/**
	 * [initDatepickerInputs description]
	 * @return {any} [description]
	 */
	initDatepickerInputs(): any {
		let _self = this;
		let inputDateArr   = $('#update-profile--date-of-birth');
		let inputExpiryArr   = $('#update-profile--passport-expiry-date');
		//let inputElArr:any = $.makeArray(inputDateArr,inputExpiryArr);
		
		let minDate = new Date((new Date().getFullYear() - 100).toString());
		let maxDate = new Date((new Date().getTime() - 1000*60*60*24*365*2));
		let expiryminDate = 0;
		let $updateProfileFlag:any   		= $('#updateProfileFlag').val();
		
		if($updateProfileFlag=="false")
		{
			let toDisableInputs:any = _self.updateForm.find('#update-profile--date-of-birth');
			
					toDisableInputs.each((i:number, el:any) => {
						$(el).attr({
							'disabled': 'disabled'
						});
						$(el).prev().css({
							'background-color': '#eee',
							'border-top-left-radius':'10px',
							'border-top-right-radius': '10px'
						});
					});					
		}

		_self.memberBase.initDatepickerInputs(inputDateArr, minDate, maxDate);
		_self.memberBase.initDatepickerInputs(inputExpiryArr, expiryminDate, );
		
	}

	initCheckboxes(): any {


		$(document).on('click', '.update--lcp--profile--consents--add', function () {
			//alert("click...");
			//var id = $(this).attr('id');
			//alert("checkbox id"+id);
			//if ($('#' + id).is(':checked')) {
				if(this.checked) {
				//alert($(this).val()+ ' is checked');
				$(this).parent().addClass('ischecked');
			}
			else{
				//alert("removed check box");
				$(this).parent().removeClass('ischecked');
			}
		});

		/*$('input[type=checkbox]').each(function () {
			$(this).on('click', (e:any) => {
				if(this.checked) {
					$(this).parent().addClass('ischecked');
				}
				else {
					$(this).parent().removeClass('ischecked');
				}
			});
		});*/
	}

	/**
	 * [initPhoneInput description]
	 * @return {any} [description]
	 */
	initPhoneInput(): any {
		let _self = this;

		let phoneCodeInputMobile   = $('#update-profile--personal-phone-mobile-country-code');

		let getPhoneOptions = $.Deferred();
		let phonecodeurl:string = '';
		/*if (window.location.hostname === 'localhost' && window.location.port == "5000") {
			phonecodeurl = '/dummy-data/PhoneCode.json';
		}
		else {
			phonecodeurl = '/content/dam/mas/json/PhoneCode.json';
		}*/
		phonecodeurl = '/content/dam/mas/json/PhoneCode.json';
		$.get(phonecodeurl)
		.done((data:any) => {
			let listItems = "<option value=''> </option>";
			if (window.location.hostname === 'localhost' && window.location.port == "5000") {
				if (typeof data === 'string') {
					data=JSON.parse(data);
				}
			}	
			for (let i = 0; i < data.Phonecodes.length; i++) {
				listItems += "<option value='" + data.Phonecodes[i].Code + "'>" + data.Phonecodes[i].Code +"</option>";
			}
			getPhoneOptions.resolve(listItems);
		})
		.fail((error:any) => {
			getPhoneOptions.reject(error);
		});

		$.when(getPhoneOptions).done(
			function(titleOptions:any) {
				phoneCodeInputMobile.html(titleOptions);

				let inputElArr = $.makeArray(_self.updateForm.find('.phoneinput'));
				_self.memberBase.initPhoneInput(inputElArr);
			});

		// change phone number field validation message
		let phoneNumberFields = _self.updateForm.find('.phoneinput input[type="tel"]');

		phoneNumberFields.each((i:number, el:any) => {
			$(el).attr({
				'data-parsley-type-message': 'This value should be a valid number.'
			});
		});
	}

	/**
	 * Initiate business address inputs when `add business address` button
	 * is clicked
	 * - hide button after clicking as well.
	 * @return {any} [description]
	 */
	initBusinessAddress(): any {
		let _self = this;
		let addBtndesk = _self.updateForm.find('.consents--add--desk');
		let addBtnmob = _self.updateForm.find('.consents--add--mob');
		//let addcheckbox_mob = _self.updateForm.find('#update-profile--subscription-preferences--mob');
		let addcheckbox_desk = _self.updateForm.find('.update-profile--subscription-preferences');
		addBtndesk.on('click', function(e:any){
			//alert("please come...");
			let agreesToselect:any;
			let agreesFromoselect:any;
			let agreesViaselect:any;
			
				agreesToselect = _self.updateForm.find('.update-profile--agreesto').val();
				agreesFromoselect = _self.updateForm.find('.update-profile--agreesfrom').val();
				agreesViaselect = _self.updateForm.find('.update-profile--agreesvia').val();
			
			
			
			/*let agreesToselect = $(".update-profile--agreesto").val();
			let agreesFromoselect = $(".update-profile--agreesfrom").val();
			let agreesViaselect = $(".update-profile--agreesvia").val();*/
			//alert("agreesToselect>>"+agreesToselect+"agreesFromoselect>>"+agreesFromoselect+"$agreesViaoselect>>"+agreesViaselect);
			var id=agreesViaselect+"--"+agreesFromoselect+"--"+agreesToselect;
			var mob_id=agreesViaselect+"--"+agreesFromoselect+"--"+agreesToselect+"-mob";
			var msg ="I Agree to receive "+agreesViaselect+" for "+agreesToselect+" From "+agreesFromoselect+" ";
			var listVals=new Array;
			var result;
			if($('.update-profile--subscription-preferences').find('.update--lcp--profile--consents--add').length !== 0)
			{
				//alert("1st if...");
				$(".update--lcp--profile--consents--add").each(function() {
					//var existid = $(this).attr('id');
					var existid = $(this).val();
						//alert("existid>"+existid);
						listVals.push(existid);
				});
				if(listVals.length>0)
				{
					for(var i=0; i<listVals.length; i++){
						var name = listVals[i];
						if(name == id){
						  result = 'Exist';
						  break;
						}
					  }
					  if(result=='Exist'){
						//alert("error...");
					  }else{
						//addcheckbox_mob.append('<div class="row"><div class="col-xs-12 col-md-8 col-sm-8"><label class="checkboxlabel checkbox profilecheckbox ischecked"><input type="checkbox" name="profile-subscribe--email-enrich" aria-label="Receive emails from Enrich" id="'+mob_id+'" value="'+id+'"  class="update--lcp--profile--consents--add" checked><label for="profile-subscribe--email-enrich">'+msg+'</label></label></div></div>');
						addcheckbox_desk.append('<div class="row"><div class="col-xs-12 col-md-8 col-sm-8"><label class="checkboxlabel checkbox profilecheckbox ischecked"><input type="checkbox" name="'+id+'" aria-label="Receive emails from Enrich" id="'+id+'" value="'+id+'"  class="update--lcp--profile--consents--add" checked><label for="profile-subscribe--consents">'+msg+'</label></label></div></div>');
					  }
				}
			}else{
				//addcheckbox_mob.append('<div class="row"><div class="col-xs-12 col-md-8 col-sm-8"><label class="checkboxlabel checkbox profilecheckbox ischecked"><input type="checkbox" name="profile-subscribe--email-enrich" aria-label="Receive emails from Enrich" id="'+mob_id+'" value="'+id+'"  class="update--lcp--profile--consents--add" checked><label for="profile-subscribe--email-enrich">'+msg+'</label></label></div></div>');
				addcheckbox_desk.append('<div class="row"><div class="col-xs-12 col-md-8 col-sm-8"><label class="checkboxlabel checkbox profilecheckbox ischecked"><input type="checkbox" name="'+id+'" aria-label="Receive emails from Enrich" id="'+id+'" value="'+id+'"  class="update--lcp--profile--consents--add" checked><label for="profile-subscribe--consents">'+msg+'</label></label></div></div>');
			}
		});
		addBtnmob.on('click', function(e:any){
			//alert("please come...");
			let agreesToselectMob:any;
			let agreesFromoselectMob:any;
			let agreesViaselectMob:any;
			
				agreesToselectMob = _self.updateForm.find('.update-profile--agreesto--mob').val();
				agreesFromoselectMob = _self.updateForm.find('.update-profile--agreesfrom--mob').val();
				agreesViaselectMob = _self.updateForm.find('.update-profile--agreesvia--mob').val();
			
			
			
			/*let agreesToselect = $(".update-profile--agreesto").val();
			let agreesFromoselect = $(".update-profile--agreesfrom").val();
			let agreesViaselect = $(".update-profile--agreesvia").val();*/
			//alert("agreesToselect>>"+agreesToselect+"agreesFromoselect>>"+agreesFromoselect+"$agreesViaoselect>>"+agreesViaselect);
			var id=agreesViaselectMob+"--"+agreesFromoselectMob+"--"+agreesToselectMob;
			var mob_id=agreesViaselectMob+"--"+agreesFromoselectMob+"--"+agreesToselectMob+"-mob";
			var msg ="I Agree to receive "+agreesViaselectMob+" for "+agreesToselectMob+" From "+agreesFromoselectMob+" ";
			var listVals=new Array;
			var result;
			if($('.update-profile--subscription-preferences').find('.update--lcp--profile--consents--add').length !== 0)
			{
				//alert("1st if...");
				$(".update--lcp--profile--consents--add").each(function() {
					//var existid = $(this).attr('id');
					var existid = $(this).val();
						//alert("existid>"+existid);
						listVals.push(existid);
				});
				if(listVals.length>0)
				{
					for(var i=0; i<listVals.length; i++){
						var name = listVals[i];
						if(name == id){
						  result = 'Exist';
						  break;
						}
					  }
					  if(result=='Exist'){
						//alert("error...");
					  }else{
						//addcheckbox_mob.append('<div class="row"><div class="col-xs-12 col-md-8 col-sm-8"><label class="checkboxlabel checkbox profilecheckbox ischecked"><input type="checkbox" name="profile-subscribe--email-enrich" aria-label="Receive emails from Enrich" id="'+mob_id+'" value="'+id+'"  class="update--lcp--profile--consents--add" checked><label for="profile-subscribe--email-enrich">'+msg+'</label></label></div></div>');
						addcheckbox_desk.append('<div class="row"><div class="col-xs-12 col-md-8 col-sm-8"><label class="checkboxlabel checkbox profilecheckbox ischecked"><input type="checkbox" name="'+id+'" aria-label="Receive emails from Enrich" id="'+id+'" value="'+id+'"  class="update--lcp--profile--consents--add" checked><label for="profile-subscribe--consents">'+msg+'</label></label></div></div>');
					  }
				}
			}else{
				//addcheckbox_mob.append('<div class="row"><div class="col-xs-12 col-md-8 col-sm-8"><label class="checkboxlabel checkbox profilecheckbox ischecked"><input type="checkbox" name="profile-subscribe--email-enrich" aria-label="Receive emails from Enrich" id="'+mob_id+'" value="'+id+'"  class="update--lcp--profile--consents--add" checked><label for="profile-subscribe--email-enrich">'+msg+'</label></label></div></div>');
				addcheckbox_desk.append('<div class="row"><div class="col-xs-12 col-md-8 col-sm-8"><label class="checkboxlabel checkbox profilecheckbox ischecked"><input type="checkbox" name="'+id+'" aria-label="Receive emails from Enrich" id="'+id+'" value="'+id+'"  class="update--lcp--profile--consents--add" checked><label for="profile-subscribe--consents">'+msg+'</label></label></div></div>');
			}
		});
	}

	validateForm(): any {
		let _self = this;

		_self.memberBase.validateForm(_self.updateForm, function(validation: any) {
			// all your custom validation here
			// let intCheckbox = _self.updateForm.find('.update-profile--interest-preferences input[type="checkbox"]');

			// intCheckbox.each(function(i:number, el:any){
			// 	$(el).attr({
			// 		'data-parsley-mincheck': 3,
			// 		'required': 'required'
			// 	});
			// });

			// let festRadio = _self.updateForm.find('.update-profile--festival-preferences input[type="radio"]');

			// festRadio.each(function(i:number, el:any){
			// 	$(el).attr({
			// 		'required': 'required'
			// 	});
			// });


			//Alpha fields
			// let alphaInputs = _self.updateForm.find('#update-profile--personal-address-line-1, #update-profile--personal-address-line-2, #update-profile--personal-address-line-3');
			// alphaInputs.attr({
			// 	'data-parsley-pattern': '^[a-zA-Z0-9 ]+$'
			// });

			// MESU-194: remove field, no need to confirm
			// confirm email validation
			// let emailId:string = 'update-profile--personal-email';
			// let confirmEmail:any = _self.updateForm.find('#update-profile--personal-email-confirm');
			// confirmEmail.attr('data-parsley-equalto', '#'+emailId);

			// postal code: only alphanumeric
			let postalCodeInput:any = $('#update-profile--personal-address-postcode');
			postalCodeInput.attr('data-parsley-type', 'alphanum');

			let nricInput:any = $('#update-profile--nric-number');
			if($('#update-profile--nric-number').is(':visible')) {
				nricInput.attr('data-parsley-pattern', '^[a-zA-Z0-9 ]+$');				
			}
			// city, state: only alphanumeric
			let cityStateInputs:any = $('#update-profile--personal-address-state');
			cityStateInputs.each((i:number, el:any) => {
				$(el).attr('data-parsley-pattern', '^[a-zA-Z ]+$');
			});

			// phone number: integer only
			let phoneInputs:any = $('#update-profile--personal-phone-mobile');
			phoneInputs.each((i:number, el:any) => {
				$(el).attr('data-parsley-type', 'integer');
			});

		}, (validation:any, formData:any, htmlFormData:any) => {
			// on success function
				let submitBtn = _self.updateForm.find('#claim-others-update');
				let successMsg = $('#update-profile-success');

				$('html, body').animate({
					'scrollTop': 0
				}, 500, () => {
					submitBtn.fadeOut();
					successMsg.fadeIn();
				});

				let disabledInputs:any = _self.updateForm.find('#update-profile--first-name, #update-profile--last-name, #update-profile--date-of-birth, #update-profile--personal-email, #update-profile--booktitle');

				disabledInputs.each((i:number, el:any) => {
					let $input = $(el);

					formData.push({
						name: $input.attr('name'),
						value: $input.val()
					});
				});


		});
	}

	/**
	 * populate input fields on page load
	 * @return {any} [description]
	 */
	populateFields(): any {
		let _self = this;
		let populateurl = $('[data-get-updateprofile-url]').attr('data-get-updateprofile-url');
		var data = {
			'action': 'fetch'
		};

		$.ajax({
			type: 'POST',
			url:populateurl,
			data: data,
			success: function(msg:any) {
				//_self.redirectUser(msg);
				if(msg != "{}")
				{
					let inputFields = {
						'title': 		 					'update-profile--title',
						'firstName': 	 				'update-profile--first-name',
						'lastName': 	 				'update-profile--last-name',
						'birthDate': 	 				'update-profile--date-of-birth',
						'gender': 		 				'update-profile--gender',
						'nationality': 		 		'update-profile--nationality',
						'nricnumber': 				'update-profile--nric-number',
						'passportnumber': 		'update-profile--passport-number',
						'passportExpiryDate':   'update-profile--passport-expiry-date',
						'contactPhoneMobile': 'update-profile--personal-phone-mobile',
						'contactCCodeMobile': 'update-profile--personal-phone-mobile-country-code',
						'contactEmail':  			'update-profile--personal-email',
						'addressLine1': 			'update-profile--personal-address-line-1',
						'addressLine2': 			'update-profile--personal-address-line-2',
						'addressLine3': 			'update-profile--personal-address-line-3',
						'addressCountry': 		'update-profile--personal-address-country',
						'addressCity': 				'update-profile--personal-address-city',
						'addressState': 			'update-profile--personal-address-state',
						'addressPostCode': 		'update-profile--personal-address-postcode',
						'subsEmail': 					'profile-subscribe--email-enrich',
						'subsEmailPartners': 	'profile-subscribe--email-enrich-partners',
						'subsPost': 					'profile-subscribe--postal-enrich',
						'subsPostPartners': 	'profile-subscribe--postal-enrich-partners',
						'subsStatements': 		'profile-subscribe--statement',
						'memberInterests': 		'update-profile--interest-checkbox'
					}; 
					let res;			
					//if (window.location.hostname === 'localhost')
					//res = msg;
					//else
					res = JSON.parse(msg);
	
					let data = {
						'title': 							res.title,
						'firstName': 					res.firstName,
						'lastName': 					res.lastName,
						'birthDate': 					res.dob,
						'gender': 						res.gender,
						'nationality': 				res.nationality,
						'nricnumber': 				res.nricnumber,
						'passportnumber': 		res.passportNumber,
						'passportExpiryDate':   res.passportExpiryDate,
						'contactPhoneMobile': res.mobileNumber,
						'contactCCodeMobile': res.countryCodeMobile,
						'contactEmail': 			res.email,
						'addressLine1': 			res.homeAddress1,
						'addressLine2': 			res.homeAddress2,
						'addressLine3': 			res.homeAddress3,
						'addressCountry': 		res.homeCountry,
						'addressCity': 				res.homeCity,
						'addressState': 			res.homeState,
						'addressPostCode': 		res.homePostCode,
						'subsEmail': 					res.emailFromEnrich,
						'subsEmailPartners': 	res.emailFromEnrichPartners,
						'subsPost': 					res.postalEnrich,
						'subsPostPartners': 	res.postalEnrichPartner,
						'subsStatements': 		res.statementMail,
						'memberInterests': [
							res.interestShopping,
							res.interestDining,
							res.interestBeauty,
							res.interestSport,
							res.interestArt,
							res.interestWine,
							res.interestCook,
							res.interestTravel,
							res.interestMovie,
							res.interestHealth,
							res.interestGolf,
							res.interestBusiness
							],
						'businessJobTitle':res.jobTitle,
						'department':res.department,
						'company':res.company
					}
	
					$.each(inputFields, (param:any, inputId:any) => {
						// console.log(param, inputId, data[param]);
	
						let input:any = $('#'+inputId);
	
						// handle select inputs
						if (input.is('select')) {
							input[0].selectize.setValue(data[param]);
						} else if (input.is('[type="checkbox"]')) {
						// handle checkbox inputs
							if (data[param]) {
								input.prop('checked', 'checked');
								input.parent().addClass('ischecked');
							}
						} else if (input.hasClass('datepicker')) {
							input.datepicker('setDate', data[param]);
							// handle date inputs
						} else {
							// handle all other inputs
							input.val(data[param]);
						}
	
						// handle group interests/festival inputs
						if (!input.length) {
							let inputGrp:any = $('[name="'+inputId+'"]');
							console.log(inputGrp.length, inputGrp);
	
							$.each(inputGrp, (i:number, inputEl:any) => {
								if ($.inArray(inputEl.value, data[param]) >= 0) {
									$(inputEl).prop('checked', 'checked');
									$(inputEl).parent().addClass('ischecked');
								}
								$(inputEl)
							});
						}
	
						input.blur();
						// manually apply state to elements if not added by blur
						input.parent().find('label').addClass('input-filled');
						input.addClass('input-focused');
					});	
					let addcheckbox_desk = _self.updateForm.find('.update-profile--subscription-preferences');
					let consensList=res.consents;
					//alert("consensList>>"+consensList);
					if(consensList!=null){
						var consSplitComma=consensList.split(',');
						for(let j=0;j<consSplitComma.length;j++){
							var consentsSplt=consSplitComma[j].split('--');
							var agreesTo=consentsSplt[0];								
							var agreesFrom=consentsSplt[1];	
							var agreesVia=consentsSplt[2];	
							var msg2:any;
							var id2:any;
							msg2 ="I Agree to receive "+agreesVia+" for "+agreesTo+" From "+agreesFrom+" ";
							id2 =agreesVia+"--"+agreesFrom+"--"+agreesTo;
							//alert("agreesTo>>"+agreesTo+"agreesFrom>>"+agreesFrom+"agreesVia>>"+agreesVia);
							addcheckbox_desk.append('<div class="row"><div class="col-xs-12 col-md-8 col-sm-8"><label class="checkboxlabel checkbox profilecheckbox ischecked"><input type="checkbox" name="'+id2+'" aria-label="Receive emails from Enrich" id="'+id2+'" value="'+id2+'"  class="update--lcp--profile--consents--add" checked><label for="profile-subscribe--consents">'+msg2+'</label></label></div></div>');
					  	}
					}
					_self.populateFlightBookingTitle();
				}
				else{
					$("#update-profile-failure").fadeIn();
				}
				
			},
			error:function(msg:any){
				console.log(msg);
			}
		});
	}

	redirectUser(msg:any) {
		if (msg.indexOf("timeout") > -1) {
			msg = msg.replace("timeout-","");
			window.location.href = msg;
		}
	}
	trackEvents() {
		let tabObj = {
			'personalDetail': 'personal-details',
			'consent': 'consent',
			'preferences': 'preferences',
			'coBrand': 'co-brand-cards'
		}
		let activeTabName: any = null;
		$('.update_tab li').click(function() {
			activeTabName = $(this).attr('data-active-tab-name');
			adobeDataLayer.push('click', {
                'pageName': '',
                'pageType': 'Enrich Profile - Personal Details',
                'clickName': 'click:tab-click:'+tabObj[activeTabName],
                'componentType': 'tab',
                'componentName': '',
                'componentID': '',
				'attributes': []
            });
		});
		$('#claim-others-submit-edit').click(function () {
			adobeDataLayer.push('click', {
                'pageName': '',
                'pageType': 'Enrich Profile - Personal Details',
                'clickName': 'click:btn-click:personal-details-update',
                'componentType': 'btn',
                'componentName': '',
                'componentID': '',
				'attributes': []
            });
		})
		$('#delete-account-btn').click(function () {
			adobeDataLayer.push('click', {
                'pageName': '',
                'pageType': 'Enrich Profile - Personal Details',
                'clickName': 'click:btn-click:delete-my-account',
                'componentType': 'btn',
                'componentName': '',
                'componentID': '',
				'attributes': []
            });
		});
		$('#claim-others-submit').click(function () {
			let clickname = null;
			if (activeTabName == 'consent') {
				clickname = 'consent-update';
			} else if (activeTabName == 'preferences') {
				clickname = 'interests-update';
			}
			adobeDataLayer.push('click', {
                'pageName': '',
                'pageType': 'Enrich Profile - Personal Details',
                'clickName': 'click:btn-click:'+clickname,
                'componentType': 'btn',
                'componentName': '',
                'componentID': '',
				'attributes': []
            });
		})
	}
}

let scope:Element = document.querySelector('#member-profile-update');

if (scope) {
	try {
	let memberupdateprofile = new memberUpdateProfile();
	var adobeDataLayer = new adobeDataLayerWrapper();	
	memberupdateprofile.initTextInputs();
	memberupdateprofile.initSelectizeInputs();
	memberupdateprofile.initDatepickerInputs();
	memberupdateprofile.initPhoneInput();
	memberupdateprofile.initCheckboxes();	
	memberupdateprofile.initBusinessAddress();
	memberupdateprofile.validateForm();
	memberupdateprofile.populateFields();
	memberupdateprofile.trackEvents();
	adobeDataLayer.push('pageLoaded', {
        'pageName': '',
        'pageType': 'Enrich Profile - Personal Details',
		'attributes': []
    });
	} catch(e) {console.error(e);}
}